var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._g(
      _vm._b(
        { staticClass: "card", style: _vm.cardStyle },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_c("div", [_vm._t("default")], 2), _vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-arrow" }, [
      _c("div", { staticClass: "card-arrow-top-left" }),
      _c("div", { staticClass: "card-arrow-top-right" }),
      _c("div", { staticClass: "card-arrow-bottom-left" }),
      _c("div", { staticClass: "card-arrow-bottom-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }